import type { MembershipRole } from "@shyne/shared/api";
import { uuid } from "@/interfaces";
import type { organization_user_status } from "@/models/organization-user.model";

export enum organization_type {
  subs = "subs",
  pmc = "pmc",
  vendor = "vendor",
  emp = "emp",
}

export interface Organization {
  id: uuid;
  display_name: string;
  description: string;
  email: string;
  type: organization_type;
  image: string;
}

export interface MemberOrganization {
  id: uuid;
  display_name: string;
  type: organization_type;
  image: string | null;
  role: MembershipRole;
  status: organization_user_status;
}
